import cn from "clsx";
import { FC, ReactNode } from "react";
import styles from "./Textarea.module.scss";

export type RightAdornmentProps = {
    children: ReactNode;
    disabled?: boolean;
};

export const RightAdornment: FC<RightAdornmentProps> = ({
    children,
    ...rest
}) => {
    if (!children) {
        return null;
    }
    return (
        <span
            {...rest}
            className={cn(styles.adornment, {
                [styles["disabled"]]: rest.disabled,
            })}
        >
            {children}
        </span>
    );
};
